import React from 'react';
import { Header } from '../components/Header';
import { Navigation } from '../components/Navigation';
import { HeroBanner } from '../components/HeroBanner';
import { WelcomeSection } from '../components/WelcomeSection';
import { ShopByVehicle } from '../components/ShopByVehicle';
import { FeaturedProducts } from '../components/FeaturedProducts';
import { CategoryBanners } from '../components/CategoryBanners';
import { TrustBadges } from '../components/TrustBadges';
import { Testimonials } from '../components/Testimonials';
import { Newsletter } from '../components/Newsletter';
import { Footer } from '../components/Footer';
interface HomePageProps {
  onNavigate: (page: 'home' | 'archive' | 'detail', productId?: number) => void;
}
export function HomePage({
  onNavigate
}: HomePageProps) {
  return <div className="min-h-screen flex flex-col bg-background font-sans" data-id="element-203">
      <Header data-id="element-204" />
      <Navigation onNavigate={onNavigate} data-id="element-205" />
      <main className="flex-grow" data-id="element-206">
        <HeroBanner data-id="element-207" />
        <WelcomeSection data-id="element-208" />
        <ShopByVehicle data-id="element-209" />
        <FeaturedProducts onNavigate={onNavigate} data-id="element-210" />
        <CategoryBanners data-id="element-211" />
        <TrustBadges data-id="element-212" />
        <Testimonials data-id="element-213" />
        <Newsletter data-id="element-214" />
      </main>
      <Footer data-id="element-215" />
    </div>;
}